/**
 * Shared session-storage slot for the WorkPeriodOverview and approval-view
 * filters. Both forms use this name (and the same field union) so the selected
 * user and month are cached and stay in sync across the two views.
 *
 * IMPORTANT: both forms MUST declare the identical set of `useForm` value keys.
 * `useForm`'s restore (retrieveFormState) discards the entire stored blob and
 * restores nothing if it finds any key the reading form doesn't declare. A field
 * added to one form but not the other therefore silently breaks restore for the
 * other view (this is what once broke Overview once the approval view wrote
 * `onlyApprovedSums`). Keep the value keys in sync in both components.
 */
export const WORK_PERIOD_FILTER_STORAGE = 'work-period-shared-filters'
